<template>
  <div>
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <img :src="imageselected" alt="Infografías principales">
      </div>
      <button class="modal-close is-large" @click="$emit('close')"></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['imageselected'],
  data () {
    return {
    }
  },
  methods:{
  },
  created :function(){
  },
  computed: {

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layouts/partials/modal.vue